// extracted by mini-css-extract-plugin
export default {"component":"HomeVRMErrors__component-bBSH","button":"HomeVRMErrors__button-vMTC","error_vehicle_lookup_failed":"HomeVRMErrors__error_vehicle_lookup_failed-k6eW"};